import React from 'react';
import Icon from '../../../components/AppIcon';

const GeographicDistribution = ({ data }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-green-50 rounded-lg">
          <Icon name="Globe" className="w-5 h-5 text-green-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Geographic Distribution</h2>
          <p className="text-sm text-gray-500">Users by region</p>
        </div>
      </div>

      <div className="space-y-4">
        {data?.map((region, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium text-gray-700">{region?.region}</span>
              <span className="text-gray-600">{region?.users?.toLocaleString()} users</span>
            </div>
            <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
              <div 
                className="absolute top-0 left-0 h-full bg-green-500 rounded-full transition-all duration-500"
                style={{ width: `${region?.percentage}%` }}
              />
            </div>
            <div className="flex items-center justify-end">
              <span className="text-xs text-gray-500">{region?.percentage}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeographicDistribution;